const EstadosConexion = {
    Conectado:"Conectado",
    Alerta:"Alerta",
    SinConexion:"Sin Conexión"
}

export default EstadosConexion;